import { ReactNode } from 'react';
import Logo from '../../../assets/images/brand/logo-mini-color.svg';
import { Button } from '../../components/atoms/Button';
import { Typography } from '../../components/molecules/Typography';
import { Icon } from '../../components/atoms/Icon';
import { useStudentAuth } from '../../../modules/Simuladao/hooks/useStudentAuth';

interface StudentAreaLayoutProps {
  children: ReactNode;
}

export default function StudentAreaLayout({ children }: StudentAreaLayoutProps) {
  const { email, name, logout } = useStudentAuth();

  return (
    <div className='min-h-screen flex flex-col bg-color-lighter'>
      {/* Header */}
      <header className='border-b-hairline border-mono-color-lightest bg-mono-color-white shadow-level-1'>
        <div className='mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8'>
          {/* Logo */}
          <div className='flex items-center gap-4'>
            <img src={Logo} alt='Aprova Total' height='32' className='h-8' />
            <div className='hidden border-l-hairline border-mono-color-light pl-4 sm:block'>
              <Typography size='small' weight='bold' className='text-brand-color-primary-pure'>
                Área de Simulados
              </Typography>
            </div>
          </div>

          {/* User Info & Logout */}
          <div className='flex items-center gap-4'>
            {/* User info display */}
            <div className='hidden items-center gap-2 rounded-lg bg-color-lightest px-4 py-2 md:flex'>
              <Icon type='material' Icon='person' className='text-brand-color-primary-pure' />
              <div className='flex flex-col'>
                {name && (
                  <Typography size='small' weight='bold' className='text-mono-color-dark'>
                    {name}
                  </Typography>
                )}
                <Typography size='small' className='text-mono-color-dark'>
                  {email}
                </Typography>
              </div>
            </div>

            {/* Logout button */}
            <Button
              variant='outlined'
              size='small'
              onClick={logout}
              className='flex items-center gap-2'
            >
              <Icon type='material' Icon='logout' className='text-sm' />
              <span className='hidden sm:inline'>Sair</span>
            </Button>
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className='flex-1 max-w-7xl self-center w-full px-4 py-8 items-center sm:px-6 lg:px-8'>
        {children}
      </main>

      {/* Footer */}
      <footer className='border-t-hairline border-mono-color-lightest bg-mono-color-white py-6'>
        <div className='mx-auto max-w-7xl px-4 sm:px-6 lg:px-8'>
          <div className='flex flex-col items-center gap-4 sm:flex-row sm:justify-between'>
            <Typography size='small' className='text-mono-color-medium'>
              © {new Date().getFullYear()} Aprova Total. Todos os direitos reservados.
            </Typography>

            <div className='flex items-center gap-4'>
              <Button
                variant='text'
                size='small'
                asLink
                to='/simuladao/login'
                className='text-brand-color-primary-pure'
              >
                Fazer novo simulado
              </Button>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
